import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { fetchBrands } from 'src/libs/api/brandApi';
import type { BrandSchema } from 'src/models/brand/schema';
import type { LOCALE_TYPE } from 'src/types/locale';
import useSWR from 'swr';

export const useBrands = (): {
  brands: BrandSchema[] | undefined;
  isLoading: boolean;
  isError: boolean;
} => {
  const { locale } = useRouter();

  const fetcher = useCallback(async (): Promise<{ brands: BrandSchema[] }> => {
    const brands = await fetchBrands(locale as LOCALE_TYPE);
    return brands.length > 0 ? { brands } : { brands: [] };
  }, [locale]);

  const { data, isLoading, error } = useSWR('/api/brands', fetcher, {
    errorRetryCount: 0,
    dedupingInterval: 86400000, // 24時間,
    fallbackData: { brands: [] }
  });
  const brands = data.brands;

  return {
    brands,
    isLoading,
    isError: !!error
  };
};
